<template>
  <div class="carousel-slide">
    <TestPixel
      v-for="(testPixel, index) of article.test_pixels"
      :key="index"
      :pixel-link="testPixel"
    />
    <a
      :aria-label="`Перейти к статье ${article.title}`"
      :href="removeBurninghutFromUrl(article.url)"
      :target="article.teaser_target === '_blank' ? '_blank' : null"
      class="carousel-slide__link"
      @click="$emit('onClickItem', article)"
    />
    <div class="carousel-slide__content">
      <div class="carousel-slide__avatar">
        <AdaptivePictureArticlesCarouselSlide :picture="article.image" />
      </div>
      <div
        :data-text="article.title"
        class="carousel-slide__title"
        v-html="article.title"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import { removeBurninghutFromUrl } from '~/utils/link';
  import { filterImages } from '~/types/utils/images';
  import type { TArticle } from '~/types/common';
  import TestPixel from '~/components/TestPixel.vue';
  import AdaptivePictureArticlesCarouselSlide from '~/components/AdaptivePictureArticlesCarouselSlide.vue';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';

  export default defineNuxtComponent({
    name: 'ArticlesCarouselSlide',

    components: {
      AdaptivePictureArticlesCarouselSlide,
      TestPixel,
    },

    inject: {
      // Категория в которой происходит событие
      // Для аналитики
      eventCategory: {
        default() {
          return () => '';
        },
      },

      // Контекст события для аналитики
      eventName: {
        default() {
          return () => 'Выбор материала_карусель внутренняя';
        },
      },
    },

    props: {
      article: {
        type: Object as PropType<TArticle>,
        required: true,
      },

      serialNumber: {
        type: Number,
        required: true,
      },
    },

    computed: {
      currentSlug(): string {
        return getSlugFromUrl(useRoute().fullPath);
      },
    },

    methods: {
      removeBurninghutFromUrl,
      filterImages,
    },
  });
</script>

<style lang="scss" scoped>
  .carousel-slide {
    border-radius: 32px;
    width: 248px;
    flex-shrink: 0;
    height: 304px;
    padding: $spacing-6 $spacing-3 $spacing-9;
    position: relative;
    overflow: hidden;
    z-index: 0;

    @include hover {
      &::before {
        opacity: 1;
      }

      .carousel-slide {
        &__title {
          @include gradientTextPseudoEl(
            $gradient: radial-gradient(74.97% 74.97% at 50% 25.03%, #e8aefc 0%, #76dddc 100%)
          );
        }

        &__comments {
          color: $onDarkColor;

          @include hover {
            color: $hover-color--1;
            .carousel-slide__comments-icon {
              background-color: $hover-color--1;
            }
          }
        }

        &__comments-icon {
          background-color: $onDarkColor;
        }
      }
    }

    &::before {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: #292236;
      opacity: 0;
      content: '';
      z-index: 1;
      pointer-events: none;
    }

    &__link {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
    }

    &__content {
      z-index: 2;
      position: relative;
      height: 100%;
    }

    &__avatar {
      width: 128px;
      height: 128px;
      border-radius: 50%;
      overflow: hidden;
      box-shadow: 4px 4px 0 black;
      margin-bottom: $spacing-4;

      :deep() {
        .picture {
          .picture__img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            overflow: hidden;
          }
        }
      }
    }

    &__img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    &__title {
      font-family: $text-font--1;
      font-weight: 500;
      position: relative;
      width: 100%;
      @include lineClampEllipsis(4);

      @include font(
        (
          'fs': 16px,
          'lh': 24px,
        )
      );
    }

    &__footer {
      margin-top: auto;
    }

    &__comments {
      display: flex;
      align-items: center;
      font-family: $text-font--1;
      font-weight: 400;
    }

    &__comments-icon {
      display: block;
      width: 24px;
      height: 24px;
      background-color: black;
    }
  }
</style>
